export default "__VITE_ASSET__BOfnoL8Q__"